<div class="search-container">
  <div #searchBar>
    <p-iconfield iconPosition="left" class="ml-auto">
      <p-inputicon>
        @if(globalSearchStatus() === 'loading'){
          <i class="pi pi-spinner pi-spin"></i>
        } @else {
          <i class="pi pi-search"></i>
        }
      </p-inputicon>
      <input class="search-bar" pInputText (focus)="onFocus()" [formControl]="searchInputForm" [style]="{height: '33px', width: '300px'}" #globalSearchInput placeholder="Search Steelworks" type="text"  />
    </p-iconfield>
  </div>

  <div class="search-dialog" #searchDialog [class.expanded]="isExpanded">
    <div class="search-dialog-content">
        <div class="search-results-container">
            <div class="search-results-menu">
              @for (item of searchMenuItems(); track item){
                <div (click)="selectedMenuItem.set(item)" class="menu-item" [class.selected]="selectedMenuItem().label === item.label">
                  <i class="icon-menu-item">
                    <ng-container
                      *ngComponentOutlet="item?.icon; inputs: {iconFill: 'var(--p-bs-globalsearch-iconcolor)'}"
                    >
                    </ng-container>
                  </i>
                  <span class="pl-2"> {{ item?.label }}</span>
                </div>
              }
            </div>
          <div class="search-results-content">
            <div class="pb-2">
              @if(searchInputForm.value){
                Search results
              } @else {
                Recent results
              }
            </div>
            <ng-container [ngTemplateOutlet]="searchResultsTemplate"
                          [ngTemplateOutletContext]="{ resultData: searchInputForm.value ? filteredGlobalSearchResults() : filteredGlobalSearchHistory() }">
            </ng-container>
          </div>
        </div>
    </div>
  </div>
</div>

<ng-template let-resultData="resultData" #searchResultsTemplate>
  @for(result of resultData; track result){
    <div (click)="itemClicked(result)" class="search-result-item">
      <div class="flex flex-row">
        @switch (result.searchType){
          @case ('CadModels') {
            <bs-cad-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="20" [height]="20"></bs-cad-icon>
          }
          @case ('Projects') {
            <bs-project-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="20" [height]="20"></bs-project-icon>
          }
          @case ('BuildKits') {
            <bs-build-kit-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="20" [height]="20"></bs-build-kit-icon>
          }
          @case ('Drawings') {
            <bs-drawing-icon [iconFill]="'var(--p-bs-globalsearch-iconcolor)'" [width]="20" [height]="20"></bs-drawing-icon>
          }
        }

        <div [style]="{'padding-left': '15px'}" class="font-normal">
          {{ result?.name }}
        </div>
      </div>
      <div [style]="{'padding-left': '35px', 'font-family': 'sans-serif', 'color': '#b6b6b6', 'font-size': '.8rem', }" class="flex gap-2 ">
        @if(result.descriptionOne !== ''){
          <span>{{ result.descriptionOne }}</span>
          &bull;
        }
        <span>{{ result.descriptionTwo }}</span> &bull; <span>{{ result.createdOn | date:'short' }} </span>
      </div>
    </div>
  }
</ng-template>

<div class="search-mask" [class.expanded]="isExpanded"></div>
